import { useMDSSession } from "@/mds/components/sessions/session-context";
import { generateSessionSummary } from "@/mds/components/sessions/session-notification/session-notification.utils";
import {
  AnySessionPart,
  ArtifactV1SessionPart,
  ArtifactV1SessionPartKind,
  SessionEventKind,
  SessionPartKind,
} from "@/mds/components/sessions/session.types";

// TODO - move to MDS context
export const SessionNotification = () => {
  const { sessionEvents } = useMDSSession();
  const { filteredEvents } = generateSessionSummary(sessionEvents);

  if (!filteredEvents || filteredEvents.length === 0) {
    return <div>Mem finished processing</div>;
  }

  // Find the latest artifact event from the filtered events
  const latestArtifactEvent = filteredEvents
    .filter(event => event.data.kind === SessionEventKind.AgentActionV1)
    .reverse() // Get the latest
    .find(event => {
      const parts = (event.data?.value?.parts || []) as AnySessionPart[];
      return parts.some(part => part.kind === SessionPartKind.ArtifactV1);
    });

  if (!latestArtifactEvent) {
    return <div>Mem finished processing</div>;
  }

  // Extract the artifact part from the latest event
  const parts = (latestArtifactEvent.data?.value?.parts || []) as AnySessionPart[];
  const artifactPart = parts.find(
    part => part.kind === SessionPartKind.ArtifactV1
  ) as ArtifactV1SessionPart;

  if (!artifactPart?.artifact_payload?.primary_label) {
    return <div>Mem finished processing</div>;
  }

  // Format the notification text based on artifact type
  const artifactKind = artifactPart.artifact_kind;
  const title = artifactPart.artifact_payload.primary_label;

  let notificationText: string;
  if (artifactKind === ArtifactV1SessionPartKind.NoteCreatedV1) {
    notificationText = `Created a note: "${title}"`;
  } else if (artifactKind === ArtifactV1SessionPartKind.NoteUpdatedV1) {
    notificationText = `Updated a note: "${title}"`;
  } else {
    notificationText = "Mem finished processing";
  }

  return <div>{notificationText}</div>;
};
